import { useEffect, useRef, useState } from 'react';

interface UseEqualHeightsOptions {
  sectionType: 'mainInfo' | 'cardFooter';
  dependencies?: any[];
}

export const useEqualHeights = ({ sectionType, dependencies = [] }: UseEqualHeightsOptions) => {
  const [maxHeight, setMaxHeight] = useState<number | null>(null);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {

    const updateHeights = () => {
      const allElements = document.querySelectorAll(`[data-section-type="${sectionType}"]`);
      
      if (allElements.length === 0) return;

      allElements.forEach((element) => {
        (element as HTMLElement).style.height = 'auto';
      });

      requestAnimationFrame(() => {
        let maxHeightValue = 0;
        allElements.forEach((element) => {
          const elementHeight = element.getBoundingClientRect().height;
          maxHeightValue = Math.max(maxHeightValue, elementHeight);
        });

        if (maxHeightValue > 0) {
          allElements.forEach((element) => {
            (element as HTMLElement).style.height = `${maxHeightValue}px`;
          });

          setMaxHeight(maxHeightValue);
        }
      });
    };

    updateHeights();

    const handleResize = () => {
      updateHeights();
    };

    window.addEventListener('resize', handleResize);

    if (dependencies.length > 0) {
      const timeoutId = setTimeout(() => {
        handleResize();
      }, 100);

      return () => {
        clearTimeout(timeoutId);
        window.removeEventListener('resize', handleResize);
      };
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [...dependencies]);

  return { elementRef, maxHeight };
};
